var slickInit;

(function ($) {

	slickInit = function () {

		$('.o-slider-section__sliders').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				autoplay: true,
				autoplaySpeed: 3000,
				speed: 1000,
				arrows: false,
				pauseOnHover: false,
				dots: true,
				rows: 0,
				loop: true,
				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});
			$(".slick-dots").wrap("<div class=\"o-section \"><div class=\"o-grid\"><div class=\"o-grid__col u-pl--0@md\"></div></div></div>");

		});
		$('.c-home-zespol__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					}
				],
				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});
		$('.c-home-projekty__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,

				responsive: [
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2
						}
					}
				],

				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});
		$('.c-home-aktualnosci__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,

				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});

	}

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}


})(jQuery);


export default slickInit;